import { registerQuery } from 'data-fetching-client';
import { getCollections, getPreviewCollections, getPublishedCollections, getRelevantCollectionIds } from '../../clients/qualityClient';
export const GET_COLLECTIONS_QUERY = registerQuery({
  fieldName: 'collections',
  args: ['appContext', 'offeringType'],
  fetcher: props => {
    if (props.appContext === 'admin-preview') {
      return getCollections(props);
    }
    return Promise.all([getRelevantCollectionIds(props), getCollections(props)]).then(([relevantIds, collections]) => {
      const relevantIdsSet = new Set(relevantIds.collectionIds);
      const relevantCollections = collections.collections.filter(collection => relevantIdsSet.has(collection.id));
      return {
        collections: relevantCollections
      };
    });
  }
});
export const GET_PUBLSIHED_COLLECTIONS_QUERY = registerQuery({
  fieldName: 'collections',
  args: ['appContext', 'offeringType'],
  fetcher: props => {
    return Promise.all([getRelevantCollectionIds(props), getPublishedCollections(props)]).then(([relevantIds, collections]) => {
      const relevantIdsSet = new Set(relevantIds.collectionIds);
      const relevantCollections = collections.collections.filter(collection => relevantIdsSet.has(collection.id));
      return {
        collections: relevantCollections
      };
    });
  }
});
export const GET_PREVIEW_COLLECTIONS_QUERY = registerQuery({
  fieldName: 'collections',
  args: ['appContext', 'offeringType'],
  fetcher: props => {
    if (props.appContext !== 'admin-preview') {
      return Promise.resolve({
        collections: []
      });
    } else {
      return getPreviewCollections(props);
    }
  }
});